module.exports = __webpack_public_path__ + "img/05_feet_Isonoe_blk.1eff986e.png";